import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { BackEndService } from '../services/backEnd.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private backend: BackEndService) {

  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.backend.session) {
      return true;
    }
    await this.backend.getSession();
    if (this.backend.session) {
      return true;
    }
    if (state.url === '/register') {
      return true;
    }
    this.router.navigate(['/register'], { replaceUrl: true });
    return false;
  }
}
